import { Controller } from "@hotwired/stimulus";

export class SelectPanelController extends Controller {
  static targets = ["summary"];

  connect() {
    this.boundPanelClosedHandler = this.updateSummary.bind(this);
    this.element.addEventListener("panelClosed", this.boundPanelClosedHandler);

    this.ensureSummaryElement();
    this.updateSummary();
  }

  disconnect() {
    this.element.removeEventListener("panelClosed", this.boundPanelClosedHandler);
  }

  closePanel(event) {
    event.preventDefault();

    if (typeof this.element.hide === "function") {
      this.element.hide();
      return;
    }

    const dialog = this.element.querySelector("dialog");
    if (dialog) dialog.close();
  }

  ensureSummaryElement() {
    if (this.hasSummaryTarget) return;

    const summary = document.createElement("span");
    summary.dataset.selectPanelTarget = "summary";
    summary.className = "ml-2 text-small color-fg-muted";

    const invoker = this.invoker;
    if (invoker?.parentElement) {
      invoker.insertAdjacentElement("afterend", summary);
    } else {
      this.element.append(summary);
    }
  }

  updateSummary() {
    if (!this.hasSummaryTarget) return;

    const count = Array.isArray(this.element.selectedItems)
      ? this.element.selectedItems.length
      : 0;

    if (count === 0) {
      this.summaryTarget.textContent = "All fields selected";
      return;
    }

    this.summaryTarget.textContent = `${count} field${count === 1 ? "" : "s"} selected`;
  }

  get invoker() {
    return (
      this.element.invokerElement ||
      this.element.querySelector("[data-show-dialog-id]") ||
      this.element.querySelector("button")
    );
  }
}
